import UibookCase from 'uibook/case'
import React from 'react'
import AiSettingsPopup from '../AiSettingsPopup'

const ACTIONS = {
  onCancel: UibookCase.event('onAiPopupCancel'),
  onReset: UibookCase.event('onAiPopupReset'),
  onSave: UibookCase.event('onAiPopupSave'),
  onMemoryClick: UibookCase.event('onAiPopupCapabilityMemoryClick'),
  onToolsClick: UibookCase.event('onAiPopupCapabilityToolsClick'),
  onWebClick: UibookCase.event('onAiPopupCapabilityWebClick')
}

const COMMENTS = {
  fast: 'Preset tuned for speed and short, utility-focused interactions.',
  balanced: 'Balanced preset for daily assistant tasks and regular chat workflows.',
  creative: 'Creative preset with full features enabled for richer generation.',
  offline: 'Air-gapped profile with web search disabled for isolated environments.'
}

export default {
  background: 'dark',
  component: AiSettingsPopup,
  i18n: true,
  cases: [
    () => <UibookCase props={{
      ...ACTIONS,
      model: 'fast',
      memoryEnabled: false,
      toolsEnabled: true,
      webEnabled: false,
      note: 'Latency target: under 500 ms for routine prompts.',
      description: COMMENTS.fast
    }}></UibookCase>,
    () => <UibookCase props={{
      ...ACTIONS,
      model: 'balanced',
      memoryEnabled: true,
      toolsEnabled: true,
      webEnabled: true,
      note: 'Default setup for mixed analytical and conversational usage.',
      description: COMMENTS.balanced
    }}></UibookCase>,
    () => <UibookCase props={{
      ...ACTIONS,
      model: 'creative',
      memoryEnabled: true,
      toolsEnabled: true,
      webEnabled: true,
      note: 'Content mode with broader style exploration and longer answers.',
      description: COMMENTS.creative
    }}></UibookCase>,
    () => <UibookCase props={{
      ...ACTIONS,
      model: 'balanced',
      memoryEnabled: true,
      toolsEnabled: true,
      webEnabled: false,
      note: 'Compliance profile for internal-only data and no external fetch.',
      description: COMMENTS.offline
    }}></UibookCase>
  ]
}
